import { useEffect, useState } from "react";

/**
 * Tracks browser connectivity via the online/offline events (event-driven,
 * not polled). navigator.onLine can still lie in edge cases (e.g. connected
 * to a LAN with no real WAN access) — callers that need a hard guarantee
 * should pair this with an actual network probe.
 */
export function useOnlineStatus() {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const goOnline = () => setIsOnline(true);
        const goOffline = () => setIsOnline(false);

        window.addEventListener("online", goOnline);
        window.addEventListener("offline", goOffline);

        return () => {
            window.removeEventListener("online", goOnline);
            window.removeEventListener("offline", goOffline);
        };
    }, []);

    return isOnline;
}
